import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { TYPE_META, fmtTime } from "./GuestCard";
import { Umbrella, Users, Clock } from "lucide-react";

export const AssignSheet = ({ reservation, lounges = [], allocByLounge = {}, onSeat, onOpenChange }) => {
  const open = !!reservation;
  const bookedType = reservation?.lounge_type;
  const free = lounges.filter((l) => !allocByLounge[l.id] && TYPE_META[l.type] && l.active !== false);
  const match = free.filter((l) => l.type === bookedType);
  const others = free.filter((l) => l.type !== bookedType);

  const Row = ({ l }) => {
    const m = TYPE_META[l.type] || TYPE_META.small;
    return (
    <button
      data-testid={`assign-spot-${l.id}`}
      onClick={() => onSeat(reservation, l)}
      className="flex w-full items-center justify-between gap-2 rounded-xl border border-sand-300 bg-white px-4 py-3.5 text-left transition-colors active:bg-sand-100"
    >
      <span className="flex items-center gap-2 font-display text-[15px] text-slate-800">
        {l.type === "umbrella" && <Umbrella size={15} className="text-sea" />}
        {l.label}
      </span>
      <span className={`flex items-center gap-1.5 text-xs font-semibold ${m.text}`}>
        <span className={`h-2 w-2 rounded-full ${m.dot}`} /> {m.label}
      </span>
    </button>
    );
  };

  return (
    <Sheet open={open} onOpenChange={(o) => { if (!o) onOpenChange(false); }}>
      <SheetContent side="bottom" data-testid="assign-sheet"
        className="max-h-[82vh] overflow-y-auto rounded-t-2xl">
        {reservation && (
          <>
            <SheetHeader className="text-left">
              <SheetTitle className="font-display text-xl tracking-wide">{reservation.guest_name}</SheetTitle>
              <SheetDescription className="sr-only">Pick a free spot to seat this guest</SheetDescription>
            </SheetHeader>
            <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-500">
              <span className={`font-semibold ${TYPE_META[bookedType]?.text}`}>{TYPE_META[bookedType]?.label}</span>
              <span className="inline-flex items-center gap-1"><Clock size={12} /> {fmtTime(reservation.start_date)}–{fmtTime(reservation.end_date)}</span>
              {reservation.party_size > 0 && (
                <span className="inline-flex items-center gap-1"><Users size={12} /> {reservation.party_size} pax</span>
              )}
            </div>
            {reservation.special_requests && (
              <p className="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-[13px] italic text-amber-800">{reservation.special_requests}</p>
            )}
            <p className="mb-2 mt-4 text-[11px] font-semibold uppercase tracking-wider text-slate-400">Choose a spot to seat</p>
            {free.length === 0 ? (
              <p className="py-8 text-center text-sm text-slate-400">No free spots right now</p>
            ) : (
              <div className="space-y-2 pb-4">
                {match.length > 0 && (
                  <>
                    <p className="px-1 text-[11px] font-medium text-slate-400">Matching {TYPE_META[bookedType]?.label}</p>
                    {match.map((l) => <Row key={l.id} l={l} />)}
                  </>
                )}
                {others.length > 0 && (
                  <>
                    <p className="mt-3 px-1 text-[11px] font-medium text-slate-400">Other spots (different size)</p>
                    {others.map((l) => <Row key={l.id} l={l} />)}
                  </>
                )}
              </div>
            )}
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
